module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/~/core-js/library/modules/_library.js
// module id = 137
// module chunks = 0